<template>
<body class="hold-transition login-page">
  <div class="login-box">
    <div class="login-logo">
      <b>own A</b> Radio
    </div>
    <!-- /.login-logo -->
    <div class="card">
      <div class="card-body">
        <div v-show="resent" class="alert alert-dismissible fade show bg-success" role="alert">
          A fresh verification link has been sent to your email address.
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <h5 class="login-box-msg">Verify Your Email Address</h5>

        <p class="mb-2 mt-2">
          Before proceeding, please check your email,
          <strong>{{authUser.email}}</strong>, for a verification link.
        </p>

        <hr />
        <p class="mb-2 text-center">If you did not receive the email</p>

        <p v-if="!loading" class="mb-1 text-center">
          <a href="#" :disabled="true" @click.prevent="resendToken">click here to request another</a>
        </p>
         <p v-if="loading" class="mb-1 text-center">
          <a>resending...</a>
        </p>
        <hr>
        <b-button class="mt-3 float-right" variant="success" @click="verified"> I've Verified </b-button>

      </div>
      <!-- /.login-card-body -->
    </div>
  </div>
  <!-- /.login-box -->
</body>
</template>

<script type="text/ecmascript-6">
import { mapState } from "vuex";
export default {
  name: "VerifyToken",

  data() {
    return {
      resent: false,
    };
  },
   computed: mapState({
      errors: (state) => state.errors,
      loading: (state) => state.loading,
      onLine: (state) => state.auth.onLine,
    }),


  methods: {

    verified(){
      window.location.href = process.env.VUE_APP_FRONTEND_BASE_URL + '/login'
    },

    resendToken() {
      this.$store
        .dispatch("RESEND_TOKEN", this.form)
        .then((res) => {
          this.$router.push('/', ()=>{})
          this.resent = true;
        })
        .catch(() => {
          this.$refs.observer.setErrors(this.errors);
        })
        
    },
  },
};
</script>
